import palette from '../../../../utilities/palette';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Tooltip } from "@mui/material";
import { useDataContext } from '../../../DataProvider/DataContext';



export default function ReorderingClusterButtons({
    machineList,
    setMachineList,
    setMachineListErrors,
    machineIndex,
    variantIndex,
    clusterIndex,
    
}) {
    const {setECUData} = useDataContext();


    const isMoveUpDisabled = clusterIndex === 0 ||
        machineList[machineIndex].variantList[variantIndex].clusterList[clusterIndex].swInstallationSequence !== 
        machineList[machineIndex].variantList[variantIndex].clusterList[clusterIndex - 1].swInstallationSequence;

    const isMoveDownDisabled = clusterIndex === machineList[machineIndex].variantList[variantIndex].clusterList.length - 1 ||
        machineList[machineIndex].variantList[variantIndex].clusterList[clusterIndex].swInstallationSequence !==
        machineList[machineIndex].variantList[variantIndex].clusterList[clusterIndex + 1].swInstallationSequence;



    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
        
        <Tooltip title={isMoveUpDisabled ? "Cannot move up cluster, either it is the first cluster or the swInstallationSequence is not the same as the previous cluster" : "Move up cluster"}>
            <KeyboardArrowUpIcon
                style={{
                    fontSize: '40px',
                    color: isMoveUpDisabled ? "lightgray" : palette.primary.main,
                    cursor: isMoveUpDisabled ? "not-allowed" : "pointer"
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    
                    if (isMoveUpDisabled) {
                        console.log("Cannot move up cluster, either it is the first cluster or the swInstallationSequence is not the same as the previous cluster");
                        return;
                    }

                    setMachineList(
                        (prevState) => {
                            const newState = [...prevState];
                            const clusterToMove = newState[machineIndex].variantList[variantIndex].clusterList[clusterIndex];
                            newState[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex, 1);
                            newState[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex - 1, 0, clusterToMove);
                            return newState;
                        }
                    );


                    // update ECUData
                    setECUData((prevState) => {
                        const newState = structuredClone(prevState);
                        const clusterToMove = newState.prefilledJSONContent.machineList[machineIndex].variantList[variantIndex].clusterList[clusterIndex];
                        newState.prefilledJSONContent.machineList[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex, 1);
                        newState.prefilledJSONContent.machineList[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex - 1, 0, clusterToMove);
                        return newState;
                    });


                    setMachineListErrors((prevState) => {
                        const newState = structuredClone(prevState);
                        const clusterToMoveErrors = newState[machineIndex].variantListErrors[variantIndex].clusterListErrors[clusterIndex];
                        newState[machineIndex].variantListErrors[variantIndex].clusterListErrors.splice(clusterIndex, 1);
                        newState[machineIndex].variantListErrors[variantIndex].clusterListErrors.splice(clusterIndex - 1, 0, clusterToMoveErrors);
                        return newState;
                    });
                }}
            />
        </Tooltip>


        <Tooltip title={isMoveDownDisabled ? "Cannot move down cluster, either it is the last cluster or the swInstallationSequence is not the same as the next cluster" : "Move down cluster"}>
            <KeyboardArrowDownIcon
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    if (isMoveDownDisabled) {
                        console.log("Cannot move down cluster, either it is the last cluster or the swInstallationSequence is not the same as the next cluster");
                        return;
                    }

                    setMachineList(
                        (prevState) => {
                            const newState = [...prevState];
                            const clusterToMove = newState[machineIndex].variantList[variantIndex].clusterList[clusterIndex];
                            newState[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex, 1);
                            newState[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex + 1, 0, clusterToMove);
                            return newState;
                        }
                    );

                    // update ECUData
                    setECUData((prevState) => {
                        const newState = structuredClone(prevState);
                        const clusterToMove = newState.prefilledJSONContent.machineList[machineIndex].variantList[variantIndex].clusterList[clusterIndex];
                        newState.prefilledJSONContent.machineList[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex, 1);
                        newState.prefilledJSONContent.machineList[machineIndex].variantList[variantIndex].clusterList.splice(clusterIndex + 1, 0, clusterToMove);
                        return newState;
                    });
                    setMachineListErrors((prevState) => {
                        const newState = structuredClone(prevState);
                        const clusterToMoveErrors = newState[machineIndex].variantListErrors[variantIndex].clusterListErrors[clusterIndex];
                        newState[machineIndex].variantListErrors[variantIndex].clusterListErrors.splice(clusterIndex, 1);
                        newState[machineIndex].variantListErrors[variantIndex].clusterListErrors.splice(clusterIndex + 1, 0, clusterToMoveErrors);
                        return newState;
                    });
                }}
                style={{marginTop: '5px',
                    fontSize: '40px',
                    // if disabled, set color to light gray
                    color: isMoveDownDisabled ? "lightgray" : palette.primary.main,
                    cursor: isMoveDownDisabled ? "not-allowed" : "pointer"                                    
                }}
            />
        </Tooltip>


        </div>
    );
}